/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Checkbox } from '@mantine/core'

const values = [6.0, 8.0]

function MandatePercentageFilter (props: FilterableProps<string>) {
  const { onChange, value } = props
  const options = values.map((value) => ({
    value: String(value),
    label: `${value}%`
  }))
  return (
    <Filter>
      {options.map((option) => (
        <Checkbox
          key={option.value}
          checked={String(value) === String(option.value)}
          label={option.label}
          name="percentage"
          onChange={handleChangeEvent(onChange)}
          value={option.value}
        />
      ))}
    </Filter>
  )
}

export default MandatePercentageFilter
